import React, {useState} from 'react'
import { FaTimes } from 'react-icons/fa'

function Tab3({values, handleChange, setFieldValue, errors, touched}) {
  const [inputValue, setInputValue] = useState('')
  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  function handleAddtags(values, setFieldValue) {
    if (inputValue !== '') {
      setFieldValue('tags', [...values.tags, inputValue])
      setInputValue('')
    }
  }

  return (
    <div className='col-lg-12'>
      <div>
        <div>
          <label className='col-form-label required fw-bold fs-6'>Tags</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 w-25'
            placeholder='Add tags'
            name='tags'
            value={inputValue}
            onChange={(e) => handleInputChange(e)}
          />
          <button
            type='button'
            className='btn btn-primary mt-4 fs-7'
            onClick={() => handleAddtags(values, setFieldValue)}
          >
            <span className='indicator-label'>Add</span>
          </button>
        </div>
        {touched.tags && errors.tags && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>{errors.tags}</span>
            </div>
          )}
        <div className='d-flex align-items-center flex-wrap gap-5 mt-5 '>
          {values.tags.map((val, index) => (
            <div 
              key={index}
              className='d-flex gap-8 align-items-center bg-light-primary px-8 py-3 rounded-4 '
              style={{cursor: 'pointer'}}
            >
              <a href='#' className='text-primary fw-semibold fs-6 me-3'>
              {val}{' '}
              </a>
              <div className="rounded-3 p-1" style={{background:'white'}}>
              <FaTimes
                  style={{
                    color: 'black',
                    cursor: 'pointer',
                    fontSize: '18px',
                  }}
                  onClick={() =>
                    setFieldValue(
                      'tags',
                      values.tags.filter((_, i) => i !== index)
                    )
                  }
                />
             </div>
            </div>
          ))}
        </div>

        {/* <button  type='button'
            className='btn btn-secondary ms-2 mt-2 me-2' key={index}>
              {val}{' '}
              <img
                style={{width: '22px', height: '22px'}}
                alt=''
                onClick={() =>
                  setFieldValue(
                    'tags',
                    values.tags.filter((_, i) => i !== index)
                  )
                }
              />
            </button> */}
      </div>
      <div className='mt-3'></div>
    </div>
  )
}

export default Tab3
